import moment from "moment";
import { conexaoDB } from "./db";

async function saveProdutos(produtos) {
  const db = await conexaoDB();
  const objectStore = db
    .transaction(["produtos"], "readwrite")
    .objectStore("produtos");

  var dtultsinc = moment().format("DD-MM-YYYY HH:mm:ss");

  objectStore.clear();
  produtos.forEach((prod) => {
    prod.dthoraultsinc = dtultsinc;
    objectStore.add(prod);
  });
}

async function saveConfigPedidos(cfg) {
  const db = await conexaoDB();
  const objectStore = db
    .transaction(["config-pedidos"], "readwrite")
    .objectStore("config-pedidos");
  objectStore.clear();
  objectStore.add(cfg);
}

async function getProdutosDB() {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    const query = db.transaction(["produtos"]).objectStore("produtos").getAll();
    query.onsuccess = (event) => {
      resolve(JSON.parse(JSON.stringify(event.target.result)));
    };
  });
}

async function getConfigPedidosDB() {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    const query = db
      .transaction(["config-pedidos"])
      .objectStore("config-pedidos")
      .getAll();
    query.onsuccess = (event) => {
      resolve(JSON.parse(JSON.stringify(event.target.result)));
    };
  });
}

async function savePedidosDB(pedido, name_db) {
  const db = await conexaoDB();

  return new Promise((resolve) => {
    const query = db
      .transaction([name_db], "readwrite")
      .objectStore(name_db)
      .add(pedido);
    query.onsuccess = (event) => {
      pedido.id_db = event.target.result;
      pedido.datahoravalidade = moment().add(7,'days').format()
      // eslint-disable-next-line
      const queryUpdate = db
        .transaction([name_db], "readwrite")
        .objectStore(name_db)
        .put(pedido, event.target.result);
      resolve(event.target.result);
    };
  });
}

async function getPedidosDB(name_db) {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    const query = db.transaction([name_db]).objectStore(name_db).getAll();
    query.onsuccess = (event) => {
      resolve(JSON.parse(JSON.stringify(event.target.result)));
    };
  });
}

async function removerPedidoDB(key, name_db) {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    let transaction = db.transaction([name_db], "readwrite");
    transaction.objectStore(name_db).delete(key);
    transaction.oncomplete = (event) => {
      resolve(event.returnValue);
    };
  });
}

async function saveDadosInsumosDB(dados) {
  const db = await conexaoDB();
  const objectStore = db
    .transaction(["insumos"], "readwrite")
    .objectStore("insumos");
  objectStore.clear();
  objectStore.add(dados);
}

async function getDadosInsumosDB() {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    const query = db.transaction(["insumos"]).objectStore("insumos").getAll();
    query.onsuccess = (event) => {
      resolve(JSON.parse(JSON.stringify(event.target.result)));
    };
  });
}

export {
  saveProdutos,
  saveConfigPedidos,
  getProdutosDB,
  getConfigPedidosDB,
  savePedidosDB,
  getPedidosDB,
  removerPedidoDB,
  saveDadosInsumosDB,
  getDadosInsumosDB,    
};
